import Request from "@services/request";
import { IGetAllFormData, IGetSingleFormData } from "./types";

const GetAllWithoutFilter = async () =>
    await new Request().get<IReturnValue<Array<ICategories["get"]>>>(
        "CATEGORIES_ALL",
    );

const GetAll = async ({ query, page }: IGetAllFormData) =>
    await new Request().get<IReturnValue<Array<ICategories["get"]>>>(
        "CATEGORIES",
        {
            params: {
                query,
                page,
            },
        },
    );

const GetSingle = async ({ id }: IGetSingleFormData) =>
    await new Request().get<IReturnValue<ICategory["get"]>>({
        base: "CATEGORY",
        params: {
            id,
        },
    });

const Create = async ({
    faName,
    enName,
    url,
    description,
    parentId,
    seoDescription,
    seoKeywords,
}: ICategories["post"]) =>
    await new Request().post<ICategories["post"], IReturnValue<any>>(
        "CATEGORIES",
        {
            faName,
            enName,
            url,
            description,
            parentId,
            seoDescription,
            seoKeywords,
        },
    );

const Edit = async ({
    id,
    faName,
    enName,
    url,
    description,
    parentId,
    seoDescription,
    seoKeywords,
}: ICategory["put"]) =>
    await new Request().put<Omit<ICategory["put"], "id">, IReturnValue<any>>(
        {
            base: "CATEGORY",
            params: {
                id,
            },
        },
        {
            faName,
            enName,
            url,
            description,
            parentId,
            seoDescription,
            seoKeywords,
        },
    );

const Delete = async ({ id }: ICategory["delete"]) =>
    await new Request().delete<IReturnValue<any>>({
        base: "CATEGORY",
        params: {
            id,
        },
    });

const UploadFile = async ({ id, file }: { id: number; file: File }) => {
    const formData = new FormData();

    formData.append("image", file);

    return await new Request().post<
        FormData,
        IReturnValue<{
            url: string;
        }>
    >(
        {
            base: "CATEGORY_IMAGE",
            params: {
                id,
            },
        },
        formData,
    );
};

const DeleteImage = async ({ id }: ICategory["delete"]) =>
    await new Request().delete<IReturnValue<any>>({
        base: "CATEGORY_IMAGE",
        params: {
            id,
        },
    });

// Main Object
const CategoriesApis = {
    GetAllWithoutFilter,
    GetAll,
    GetSingle,
    Create,
    Edit,
    Delete,
    UploadFile,
    DeleteImage,
};

export default CategoriesApis;
